const links = [
    {
      text: "Boletim de Caixa",
      icon: "mdi-cash-register",
      route: "/checkcashierslip",
      class: "white--text",
      active: true
    },
  ];
  export { links };